import { createSlice } from "@reduxjs/toolkit";
import { getDocs, collection, query, where } from "firebase/firestore";
import { firestore } from "../../config/fbConfig";

//Initial Value of Slice
const initialState = {
  EmpPaymentHistory: [],
  loading: false,
  error: null,
};

//Action of Slice
const EmpPaymentHistorySlice = createSlice({
  name: "EmpPaymentHistory",
  initialState,
  reducers: {
    setEmpPaymentHistoryStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    setEmpPaymentHistorySuccess: (state, action) => {
      state.loading = false;
      state.EmpPaymentHistory = action.payload;
    },
    setEmpPaymentHistoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

//Export of Slice
export const {
  setEmpPaymentHistoryStart,
  setEmpPaymentHistorySuccess,
  setEmpPaymentHistoryFailure,
} = EmpPaymentHistorySlice.actions;
export default EmpPaymentHistorySlice.reducer;

export const fetchEmpPaymentHistory = (userUUID) => async (dispatch) => {
  try {
    dispatch(setEmpPaymentHistoryStart());

    const q = query(
      collection(firestore, "Payments"),
      where("ClientId", "==", userUUID)
    );

    const querySnapshot = await getDocs(q);

    const EmpPaymentHistory = [];
    querySnapshot.forEach((doc) => {
      EmpPaymentHistory.push(doc.data());
    });
    dispatch(setEmpPaymentHistorySuccess(EmpPaymentHistory));
  } catch (error) {
    dispatch(setEmpPaymentHistoryFailure(error.message));
  }
};
